import { render, staticRenderFns } from "./BaseFileNfe.vue?vue&type=template&id=4bfe069e&scoped=true&"
import script from "./BaseFileNfe.vue?vue&type=script&lang=js&"
export * from "./BaseFileNfe.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileNfe.vue?vue&type=style&index=0&id=4bfe069e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe069e",
  null
  
)

export default component.exports